<template lang="pug">
div
  slot(name="activator" :toggle="toggle")
    v-btn(small color='primary' 
      @click="toggle" 
      :disabled="disabled"
      outlined
    ) {{ title }}
  v-dialog(v-model="showing" scrollable max-width=800)
    v-card(data-test="c-exchange-body")
      v-card-title(data-test="c-exchange-title") {{ title }}
      v-card-text
        reservations(:formErrors="formErrors" ref="reservations" addText="add exam"
          :getExamLocation="getExamLocation"
          :getCourseLocation="getCourseLocation"
          :model="model"
          :avaliableSlots="false"
          :onHoldShowing="false"
        )
          template(v-slot:form="form")
            slotsProvider(v-slot="slots" :key="showing")
              reservationSlotsProvider(
                :examDate="form.item.examDate"
                :examLocation="form.item.location"
                @change="slots.loadList"
                v-slot="slotsCheck"
              )
                list(
                  v-if="Object.keys(slots.model.list).length"
                  :model="slots.model"
                  :loading="slots.loading"
                  :pagination="slots.pagination"
                  @change:location="slotsCheck.checkDataToLoadList"
                  @change:examDate="slotsCheck.checkDataToLoadList"
                  v-show="!slots.loadingErr"
                )

        div.text-center.mt-3
        
      v-card-actions
        v-spacer
        v-btn(color="error" text @click="toggle") Close
        v-btn(color="success" data-test="c-exchange-submit" text @click="submit" :loading="loading") Add exams
</template>
<script>
import errorsMixin from '@/mixins/errors.mixin'
import examActionsMixin from '../core/mixins/exam-actions.mixin'
import { dateFormating } from '../../../../../util'
import { API_ATTRIBUTES_NESTED } from '../core/candidates-const'
import CourseModel from '../../../models/courseModel'
import Model from "../core/candidates-reservation-model"

export default {
  mixins: [errorsMixin, examActionsMixin],
  props: {
    exchange: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Add exam requests"
    },
    defaultCourse: Object
  },

  methods: {
    async send(payload) {
      try {
        this.loading = true
        let ids = this.activeItems.map(item => item.ID)
        let exchangeRequests = this.model._getRequestsApiDataBy(this.$refs.reservations.requests, this.exchange)
        let res = await this.svc().addRequests({ids: ids, exchangeRequests: exchangeRequests})
        this.$notify({text: 'Exchange list sended', type: 'success'})
        this.toggle()
        this.$emit('send', res)
      } catch (error) {
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE,
          formErrors: this.formErrors, 
          apiAttributes: {
            exams: 'requests'
          },
          nestedErrors: API_ATTRIBUTES_NESTED
        });
      }
      finally {
        this.loading = false
      }
    },
  },

  watch: {
    showing(isShowing) {
      if(!isShowing) {
        this.model = new Model()
        this.$refs.reservations.resetRequests()
        return
      }
      if((this.defaultCourse && this.defaultCourse.item && !this.exchange) || (this.exchange && this.activeItems.length === 1)) {
        let course = new CourseModel({
          id: this.defaultCourse.item.ID,
          date: this.defaultCourse.item._date,
          name: this.defaultCourse.item.name,
          city: this.defaultCourse.item.city

        })
        this.model.requests[0].course = course
        this.$refs.reservations && this.$refs.reservations.setRequests()
        this.model.requests[0].course = this.defaultCourse.item
        // this.autocompleteExam(this.requests[0])
      }
    }
  },

  components: {
    exchangeItem: () => import('./CandidatesExchangeItem.vue'),
    list: () => import('@/app/admin/modules/slots/components/SlotsList.vue'),
    slotsProvider: () => import('@/app/admin/modules/slots/components/SlotsProvider.vue'),
    reservationSlotsProvider: () => import('./CandidatesReservationSlotsProvider.vue')
  }
}
</script>
